import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormCard, Row } from './components'
import { TextField, Stack } from '@mui/material'
import Select from '@/components/Select'
import Text from '@/components/Text'
import Form, { FormItem } from '@/components/Form'
import Button, { ConfirmButton } from '@/components/Button'
import { CreateTicket as CreateTicketValue } from '@/types'
import { getApplications, createTicket, UploadImage } from '@/api'
import { useQuery, useMutation } from '@tanstack/react-query'
import ImageUploader from '@/components/ImageUploader'
import { Message } from '@cx/ui'

const ticket_type = ['故障', '建议', '其他']

const CreateTicket: React.FC<unknown> = () => {
  const navigate = useNavigate()
  const [formValue, setFormValue] = useState<CreateTicketValue>()
  const [hasError, setHasError] = useState<boolean>(false)
  const [validating, setValidation] = useState<boolean>(false)
  const [images, setImages] = useState<string[]>([])

  const { data: market } = useQuery(['getApplications'], getApplications, {})

  const goBack = useCallback(() => {
    navigate('/console/account/tickets')
  }, [navigate])

  const createTicketMutation = useMutation(createTicket, {
    onSuccess: () => {
      setValidation(false)
      Message.success('工单创建成功')
      goBack()
    },
  })

  const handleCreate = useCallback(() => {
    setValidation(true)
    if (!hasError) {
      // @ts-ignore
      createTicketMutation.mutate({ ...formValue, images })
    }
  }, [createTicketMutation, formValue, hasError, images])

  const handleValidate = useCallback((validateState: boolean) => {
    setHasError(validateState)
  }, [])

  const handleChangeImages = useCallback((images: string[]) => {
    setImages(images)
  }, [])

  return (
    <Stack sx={{ height: '100%', gap: '30px' }}>
      <Text weight='bold'>创建工单</Text>
      <Stack sx={{ flex: 1 }}>
        <FormCard>
          <Form
            sx={{
              flexDirection: 'row',
              gap: '24px',
              flexWrap: 'wrap',
              width: '100%',
            }}
            initialValue={formValue}
            // @ts-ignore
            onFormValueChange={setFormValue}
            // @ts-ignore
            onValidate={handleValidate}
            validating={validating}
          >
            <FormItem
              sx={{ flex: 1, flexBasis: '55%' }}
              label='title'
              text='标题'
              rules={{
                required: true,
                errorMessage: '请输入标题',
                validator: (value: string) => value?.length > 0,
              }}
            >
              <TextField placeholder='标题建议列明问题出现的产品名称或关键词' />
            </FormItem>
            <FormItem
              sx={{ flex: 1, flexBasis: '45%' }}
              label='app_id'
              text='产品类型'
              rules={{
                required: true,
                errorMessage: '请输入标题',
                validator: (value: number) => !isNaN(value),
              }}
            >
              <Select
                options={
                  market?.data
                    ? [
                        { label: '其他', value: 0 },
                        ...market?.data?.map((pd) => ({
                          label: pd.name,
                          value: pd.id,
                        })),
                      ]
                    : []
                }
              />
            </FormItem>
            <FormItem
              sx={{ flex: 1, flexBasis: '45%' }}
              label='ticket_type'
              text='工单类型'
              rules={{
                required: true,
                errorMessage: '请输入标题',
                validator: (value: number) => !!value,
              }}
            >
              <Select
                options={ticket_type?.map((type, index) => ({
                  label: type,
                  value: index + 1,
                }))}
              />
            </FormItem>
            <FormItem
              sx={{ flex: 1, flexBasis: '55%' }}
              label='content'
              text='内容描述'
              rules={{
                validator: () => true,
              }}
            >
              <TextField
                multiline
                rows={3}
                maxRows={5}
                variant='outlined'
                InputProps={{
                  sx: {
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #D9D9D9FF',
                    },
                    backgroundColor: '#fff',
                    flexDirection: 'column',
                  },
                  endAdornment: (
                    <ImageUploader
                      max={3}
                      sx={{ width: '100% ' }}
                      onUpload={UploadImage}
                      value={images}
                      onChange={handleChangeImages}
                    />
                  ),
                }}
              />
            </FormItem>
          </Form>
        </FormCard>
      </Stack>

      <Row sx={{ justifyContent: 'flex-end', gap: '16px' }}>
        <Button type='secondary' onClick={goBack}>
          取消
        </Button>
        <ConfirmButton onClick={handleCreate}>提交工单</ConfirmButton>
      </Row>
    </Stack>
  )
}

export default CreateTicket
